import { Controller } from "@hotwired/stimulus";
import pcmProcessorUrl from "@/utilities/pcm_processor.js?url";

export default class extends Controller {
  static outlets = ["store-audio--recorder"]
  static targets = ["container", "ping"]
  static values = { path: String, isPause: Boolean }

  disconnect() {
    this.#cleanup();
  }

  async start() {
    const response = await fetch(this.pathValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
        "Accept": "application/json"
      }
    });
    const { url } = await response.json();

    this.ws = new WebSocket(url);
    this.ws.binaryType = "arraybuffer";

    this.ws.onopen = async () => {
      this.audioContext = new AudioContext({ sampleRate: 16000 });
      await this.audioContext.audioWorklet.addModule(pcmProcessorUrl);

      const source = this.audioContext.createMediaStreamSource(this.storeAudioRecorderOutlet.stream);
      this.workletNode = new AudioWorkletNode(this.audioContext, "pcm-processor");
      source.connect(this.workletNode);

      this.workletNode.port.onmessage = (event) => {
        if (!this.isPauseValue && this.ws.readyState === WebSocket.OPEN) {
          this.ws.send(event.data);
        }
      };
    };

    this.ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.type === "transcript") {
        const { is_final, id, utterance } = data.data;
        if (is_final) {
          const partialEl = this.containerTarget.querySelector(`[data-utterance-id="${id}"]`);
          if (partialEl) partialEl.textContent = utterance.text;
          else this.containerTarget.insertAdjacentHTML("beforeend", `<span>${utterance.text} </span>`);
        } else {
          let el = this.containerTarget.querySelector(`[data-utterance-id="${id}"]`);
          if (!el) {
            el = document.createElement("span");
            el.dataset.utteranceId = id;
            this.containerTarget.appendChild(el);
          }
          el.textContent = utterance.text;
        }
      }
    };
  }

  pause() {
    this.isPauseValue = true;
  }

  resume() {
    this.isPauseValue = false;
  }

  stop() {
    if (this.ws?.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify({ type: "stop_recording" }));
    }
    this.#cleanup();
  }

  isPauseValueChanged() {
    this.pingTarget.classList.toggle("hidden", this.isPauseValue);
    this.pingTarget.classList.toggle("inline-block", !this.isPauseValue);
  }

  #cleanup() {
    this.workletNode?.disconnect();
    this.audioContext?.close();
    this.ws?.close();
    this.workletNode = null;
    this.audioContext = null;
    this.ws = null;
  }
}
